import React, { FC } from 'react';
import { CarsBar as CarsBarWrap, CarsBarFound, CarsBarSort } from '@azgaz/azgaz-ui';
import { useSelector, selectors, useDispatch, actions } from '@lib/azgaz-ui/connect';

const CarsBar: FC = () => {
  const loading = useSelector(selectors.getCarsLoading);

  const { sort } = useSelector(selectors.getResultParams);
  const carsCount = useSelector(selectors.cars.getCarsCount)
  const dispatch = useDispatch();

  return (
    <CarsBarWrap>
      <CarsBarFound total={carsCount.all} loading={loading} title="В наличии:" />
      <CarsBarSort
        current={sort || 'price'}
        setSort={value => dispatch(actions.setSort(value))}
        options={[{ id: 'price', label: 'Цене' }]}
      />
    </CarsBarWrap>
  );
};

export default CarsBar;
